import { action,  observable } from "mobx";

import Cloudplay from '@/components/BroadcastFlow/sdk';
import GlobalStore from '@/store/GlobalStore';
import HomeStore from '@/store/HomeStore';
import router from '@/router';
import log from '@/utils/log';

const defaultErrorText = '您的云手机跪了,请检查网络或云手机';

const errTexts = {

  instanceError:'实例出错',
  tokenExpire: 'Token 失效',
  maintainServer: '正在维护服务器',
  unsupportDevice: '设备不支持',
  unsupportWechat: '微信不支持',
  internalError: '内部错误',
  internal: '主动停止',
  networkOff: '链接断开'

}

class DevicePlayStore {


  // 菜单状态
  @observable menuVisibility = false

  // 弹窗
  @observable modalVisibility = false

  @observable loadingVisibility = true

  @observable error = false

  @observable errorText = defaultErrorText

  // 分辨率列表
  @observable resolutionList

  // 当前分辨率
  @observable currentResolution

  @action.bound async setMenuVisibility (state: boolean) {
    await log.logRequest({eventId: 'N0902',failReason: String(state) })
    this.menuVisibility = state;
  }

  @action.bound setModalVisibility (state: boolean) {
    this.modalVisibility = state;
  }

  @action.bound init () {
    this.error = false
  }


  @action.bound routerPushHome () {
    router.push({path: 'home'})
  }

  @action.bound initSdk (id: string) {
    console.log(id,Cloudplay.initSDK);
    Cloudplay.initSDK(id,{
      accessKeyId: HomeStore.cloudDevicePlayInfo.accessKeyId,
      phoneId: HomeStore.cloudDevicePlayInfo.cid,
      pkgName: HomeStore.cloudDevicePlayInfo.pkgName,
      cToken: HomeStore.cloudDevicePlayInfo.accessToken,
      autoPlayAudio: true,
      isPortrait: true,
      userInfo: {
        uId: window.localStorage.getItem('account') || 'test123',
        uToken: window.localStorage.getItem('account') || 'test123',
      },
      onSceneChanged: (sceneId: any, extraInfo: any) => {
        console.log(sceneId, extraInfo);

        if (sceneId === 'play') {
          this.loadingVisibility = false;
          this.error = false;
        }

        if (sceneId === 'stop') {
          if (extraInfo.reason === 'normal') return
          GlobalStore.toast.text(extraInfo.message)
          this.loadingVisibility = true
          this.error = true

          const errNames = Object.assign(errTexts)
          if (errNames.indexOf(extraInfo.reason) !== -1) {
            this.errorText = errNames[extraInfo.reason]
          }
        }

        if (sceneId === 'resolutionList') {
          this.resolutionList = extraInfo.list
        }

        if (sceneId === 'currentResolution') {
          this.currentResolution = extraInfo.info
        }

        if (sceneId === 'changeResolution') {
          if (extraInfo.reason === 'start') {
            GlobalStore.toast.text('开始切换分辨率')
          }
          if (extraInfo.reason === 'end') {
            const index = this.resolutionList.map((r: { id: any; }) => r.id).indexOf(this.currentResolution.id)
            const name = this.resolutionList[index].name;
            GlobalStore.toast.text(`已成功切换到${name}`)
          }
        }

        console.log(sceneId,extraInfo)
      },
      MessageHandler: function (message: any) {
        console.log(message);
      }
    })
  }

  @action.bound startSdk(id: string) {

  }

  // 首页
  @action.bound async cloudplayHome () {
    await log.logRequest({eventId: 'N0904'})
    Cloudplay.sendVirtualBtnPoint('home');
    await this.setMenuVisibility(false)
  }

  // 切换
  @action.bound async cloudplayMeun () {
    await log.logRequest({eventId: 'N0906'})
    Cloudplay.sendVirtualBtnPoint("menu");
    await this.setMenuVisibility(false)
  }

  // 返回
  @action.bound async cloudplayBackspace() {
    await log.logRequest({eventId: 'N0905'})
    Cloudplay.sendVirtualBtnPoint('backspace');
  }

  // 切换清晰度
  @action.bound async cloudplayResolutionPhone(id: any) {
    await log.logRequest({eventId: 'N0903'})
    Cloudplay.switchResolution(id)
    await this.setMenuVisibility(false)
  }

  // 断开播流
  @action.bound async cloudplayStopSDK (pageName: string | null | undefined) {
    await log.logRequest({eventId: 'N0907'})
    Cloudplay.stopGame((res) => {
      if (pageName === 'devicePlay' && res.code === 0) {
        window.location.replace('/home')
        // router.push({path: 'home'})
      }
    });
    this.recovery()

  }

  @action.bound recovery () {
    // 菜单状态
  this.menuVisibility = false

    // 弹窗
  this.modalVisibility = false

  }



}

export default new DevicePlayStore();
